import { ReadOnlyModel } from 'core/models/readOnly.model.js';

export var CompteursModel = ReadOnlyModel.extend({

  defaults: {
    libelle: "",
    valeur: ""
  }
});